export class ChangePassword{
    
    secUsrId:string;
    secUsrPwd:string;
    secUsrLogin:string;
    secUsrOldPswd:string;
}